import Box from '@material-ui/core/Box';
import Drawer from '@material-ui/core/Drawer';
import React, { useEffect } from 'react';
import { makeStyles, IconButton, withMobileDialog, Typography } from '@material-ui/core';
import CloseIcon from 'mdi-material-ui/Close';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

const propTypes = { onClose: PropTypes.func.isRequired, title: PropTypes.string };
const defaultProps = { title: '' };
const styles = makeStyles(({ spacing, width, breakpoints }) => ({
    drawer: {
        width: width.drawerRight,
        flexShrink: 0,

        [breakpoints.down('md')]: {
            width: '100%',
            height: '100%',
        },
    },
    drawerPaper: {
        width: width.drawerRight,

        [breakpoints.down('md')]: {
            width: '100%',
            height: '100%',
        },
    },
}));

function CustomDrawer({
    fullScreen, children, title, onClose, open, ...props
}) {
    const classes = styles();
    const { nav: { toggleRightDrawer } } = useDispatch();

    // useEffect(() => {
    //     if (open) {
    //         toggleRightDrawer(true);
    //     } else {
    //         toggleRightDrawer(false);
    //     }
    // }, [open, toggleRightDrawer]);

    return (
        <Drawer
            {...props}
            open={open}
            onClose={() => onClose}
            anchor={fullScreen ? 'bottom' : 'right'}
            variant="persistent"
            className={classes.root}
            classes={{ paper: classes.drawerPaper }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" px={2} pt={2} mt={8}>
                <Typography variant="h6">{title}</Typography>
                <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </Box>
            {children}
        </Drawer>
    );
}

CustomDrawer.propTypes = propTypes;
CustomDrawer.defaultProps = defaultProps;

export default withMobileDialog()(CustomDrawer);
